import { CommonModule, CurrencyPipe } from "@angular/common";
import { Component, Input, inject } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { StoreFacadeService } from "src/app/pages/store-management/stores/stores-facade.service";
import { ProviderGetDTO } from "src/app/pages/providers/provider.model";
import { ProgressBarWidgetComponent } from "src/app/shared/components/treeslo-grid/widgets/progress-bar/progress-bar-widget.component";
import { ProviderReportData } from "../models/provider-report.model";

@Component({
  selector: "app-store-provider-report-responsive-card",
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    CurrencyPipe,
    MatTooltipModule,
    ProgressBarWidgetComponent,
  ],
  templateUrl: "./store-provider-report-responsive-card.component.html",
  styleUrls: ["./store-provider-report-responsive-card.component.scss"],
})
export class StoreProviderReportResponsiveCardComponent {
  private readonly facadeSvc = inject(StoreFacadeService);

  @Input({ required: true }) row!: ProviderReportData;
  @Input({ required: true }) providers: ProviderGetDTO[] = [];

  readonly translationPrefix = "dashboard.column_store_provider_report";

  getProviderName(providerKey?: string): string {
    if (!providerKey) {
      return "---";
    }

    return this.findProviderMatch(providerKey)?.name || providerKey;
  }

  getProviderLogo(providerKey?: string): string {
    const match = this.findProviderMatch(providerKey ?? "");
    return this.facadeSvc.getProviderLogo(match?.value || providerKey || "");
  }

  isAmazonProvider(providerKey?: string): boolean {
    const normalized = (providerKey || "").toLowerCase();
    const match = this.findProviderMatch(providerKey ?? "");
    const providerValue = (match?.value || providerKey || "").toLowerCase();

    return providerValue.includes("amazon") || normalized.includes("amazon");
  }

  successRateEvaluator = (percentage: number): string => {
    if (percentage < 20) {
      return "danger";
    }
    if (percentage < 50) {
      return "warning";
    }
    if (percentage < 80) {
      return "info";
    }
    return "success";
  };

  private findProviderMatch(providerKey: string): ProviderGetDTO | undefined {
    const normalizedKey = providerKey.trim().toLowerCase();

    return this.providers.find(
      (provider) =>
        provider.value === providerKey ||
        provider.name === providerKey ||
        provider.value.toLowerCase() === normalizedKey ||
        provider.name.toLowerCase() === normalizedKey,
    );
  }
}
